"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CodingLayer_exports = {};
__export(CodingLayer_exports, {
  default: () => CodingLayer_default
});
module.exports = __toCommonJS(CodingLayer_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9965 4.36986L4.48934 8.50033L11.9965 12.6308L19.5092 8.50033L11.9965 4.36986ZM12.4782 3.26531C12.1781 3.10031 11.8145 3.10037 11.5144 3.26546L3.59239 7.62419C2.9018 8.00416 2.9018 8.9965 3.59239 9.37647L11.5144 13.7352C11.8145 13.9003 12.1781 13.9003 12.4782 13.7353L20.4062 9.37662C21.0971 8.99673 21.0971 8.00392 20.4062 7.62404L12.4782 3.26531ZM21.0304 12.2197C21.1853 12.5126 21.0735 12.8757 20.7806 13.0307L12.7447 17.2817C12.2764 17.5294 11.716 17.5293 11.2478 17.2814L3.21925 13.0306C2.9264 12.8755 2.81469 12.5124 2.96975 12.2195C3.1248 11.9267 3.48791 11.815 3.78076 11.97L11.8093 16.2209C11.9264 16.2828 12.0665 16.2829 12.1835 16.2209L20.2194 11.9699C20.5124 11.815 20.8754 11.9268 21.0304 12.2197ZM20.7806 16.5307C21.0735 16.3757 21.1853 16.0126 21.0304 15.7197C20.8754 15.4268 20.5124 15.315 20.2194 15.4699L12.1835 19.7209C12.0665 19.7829 11.9264 19.7828 11.8093 19.7209L3.78076 15.47C3.48791 15.315 3.1248 15.4267 2.96975 15.7195C2.81469 16.0124 2.9264 16.3755 3.21925 16.5306L11.2478 20.7814C11.716 21.0293 12.2764 21.0294 12.7447 20.7817L20.7806 16.5307Z",
      fill: "currentColor"
    }
  )
);
const SvgCodingLayer = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CodingLayer_default = SvgCodingLayer;
